import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = ' Внутренний туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Туризм внутри страны. Особенностью внутреннего туризма является временный выезд граждан
                        конкретной страны с постоянного места жительства для отдыха, удовлетворения познавательных
                        интересов, занятий спортом и других туристских целей, который осуществляется только в пределах
                        национальных границ этой страны.</p>
                    <p>Используется для определения туризма резидентов в пределах собственной страны. В международных
                        расчетах и статистике внутренний туризм может относиться к определению деятельности и расходов
                        на туризм и нерезидентов в данной стране. Внутренний туризм не представляет собой отдельную
                        сферу, а связан со всеми другими секторами национальной жизни.</p>
                </div>
            </div>
        </>
    );
}